import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios'; // Don't forget to import axios
import 'react-toastify/dist/ReactToastify.css';
import '../sunpharma(1)/css/lea_event.css';

import Footer from '../components/footer';
import Com_Logo from '../components/company_icon';


const CardSelector = () => {
  const [activity, setActivity] = useState([]); // Initialize with an empty array
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [visibleCount, setVisibleCount] = useState(0);
  const navigate = useNavigate();

     // Get values from sessionStorage
  const Usertype = sessionStorage.getItem('user_type'); // from login
  const Check_event = sessionStorage.getItem('event');  // from event page
  
  // console.log('usertype:', Usertype);
  // console.log('event:', Check_event);
  // console.log('lea_event:',l_card)

  useEffect(() => {
    if (Usertype && Check_event) {
      axios
          //http://localhost/PROJECT/REACT/lms/src/api/activity.php
          //./api/activity.php
        .get('./api/activity.php', {
          params: {
            user_type: Usertype,       // ✅ matches $_GET['user_type']
            check_event: Check_event,  // ✅ matches $_GET['check_event']
          },
        })
        .then((response) => {
          if (response.data.status) {
            setActivity(response.data.answer); // e.g., ['Video', 'Book']
          } else {
            // console.error('No activity data:', response.data.message);
          }
        })
        .catch((error) => {
          // console.error('Error fetching data:', error);
        });
    }
  }, [Usertype, Check_event]);


  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCount((prev) => {
        if (prev < activity.length) {
          return prev + 1;
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, 200); // 1 second interval to reveal cards

    return () => clearInterval(interval);
  }, [activity]);

  const handleSelect = (index) => {
    setSelectedIndex(index);
  };

  const handleNext = () => {
    if (selectedIndex !== null) {
      const selectedCard = activity[selectedIndex];

    // Store the card title in sessionStorage(im_url pan jode ave atle selectedCard.title lakhvupadse alag padva mate)
      sessionStorage.setItem('lea_event', selectedCard.title);
      const l_card_title = sessionStorage.getItem('lea_event', selectedCard.title);
      // console.log('selectedCard',selectedCard)

      //vadu cards hoy to else if condition lagavi
      if(l_card_title === 'E - Video' && Usertype === 'sunpharma')
      {

      // Show toast with selected card title and redirect
      toast.success(`Selected : ${selectedCard.title}`, {
        position: 'top-right',
        autoClose: 2000,
        onClose: () => {
          navigate('/lea_video', { state: { selected: selectedCard } });
        },
      });
    }
    
    else if(l_card_title === 'E - Virtual meeting' && Usertype === 'sunpharma'){
      toast.success(`Selected : ${selectedCard.title}`, {
        position: 'top-right',
        autoClose: 2000,
        onClose: () => {
          navigate('/lea_virtual', { state: { selected: selectedCard } });
        },
      });
    }

   
    else if(l_card_title === 'E - Video' && Usertype === 'medeuon'){
      toast.success(`Selected : ${selectedCard.title}`, {
        position: 'top-right',
        autoClose: 2000,
        onClose: () => {
          navigate('../medeuon(2)/lea_video', { state: { selected: selectedCard } });
        },
      });
    }

    else if(l_card_title === 'E - Virtual meeting' && Usertype === 'medeuon'){
      toast.success(`Selected : ${selectedCard.title}`, {
        position: 'top-right',
        autoClose: 2000,
        onClose: () => {
          navigate('../medeuon(2)/lea_virtual', { state: { selected: selectedCard } });
        },
      });
    }

    else{
      toast.warning("Please select your activity", {
        position: 'top-right',
        autoClose: 2000,
      });
    }

    }
  };

  const Prev =() => {
    navigate('../event')
  }



  return (
    <>
      <Com_Logo/>
      <div className="card-container">
        <div className='lea_wr'>    
          <h2 className="video-title_lea_event">Learning Event</h2>
        </div>

        <div className="card-row">

      {activity.slice(0, visibleCount).map((card, index) => (
        <div
                key={index}
                className={`lea_card-box ${selectedIndex === index ? 'selected' : ''}`}
                onClick={() => handleSelect(index)}
              >
                {/* // img img folder ma che pan ano path database mathee avse */}
                <img src={`./img/${card.img_url}`} alt={card.title} />

                <div className="card-title">{card.title}</div>
              </div>
            ))}
        </div>

         {/* Navigation Buttons Container */}
        <div className="navigation-buttons_ls">
          <button className="nav-button_prev_ls"  onClick={Prev}>Prev</button>

          <button
            className="nav-button_next_ls"
            onClick={handleNext}>
            Next
          </button>
        </div>

        {/* Toast container */}
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
};

export default CardSelector;
